export default "__VITE_ASSET__c30a6d44__"